import React from "react";

const SeasonTeamTitle = ({ record }) => {
  const { team, seasonCode } = record;
  const { school } = team;
  let title = "";

  if (school && school.name) title = `${school.name} `;
  if (team && team.name) title = title.concat(`${team.name} `);
  if (seasonCode) title = title.concat(seasonCode);

  return <span>{title}</span>;
};

export default SeasonTeamTitle;
